// Copyright (c) 2019-present Ladifire, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import Spinner from './components';

export default Spinner;
export {SpinnerSizes, SpinnerProps, SpinnerPhases} from './types';
